import React, { useState, useRef } from "react";

// import VendorList from "./VendorList";
import { Link } from "react-router-dom";
import Addingemployees from "../Food/Addingemployees";
import Cateringbillingsetup from "./Cateringbillingsetup";


const Cateringsetiingspage = () => {
    const [activeTab, setActiveTab] = useState("Billing Setup");

    const tabContent = {
        // Employee: <Addingemployees />,
        "Billing Setup": <Cateringbillingsetup />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                {/* <div className="col-lg-2"></div> */}
                <div className="col-lg-12" style={{ height: "80vh", overflowY: "auto", marginTop: "0px", scrollbarWidth: "none" }}>

                    <div className="discount-container">
                        {/* Responsive, centered tab buttons */}
                        <div

                            className="rorr row b2"
                        >

                        </div>
                        {/* Tab Content - Scrollable Part */}
                        <div
                            style={{
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                // paddingTop: "20px",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default Cateringsetiingspage;
